module.exports = __webpack_public_path__ + "static/media/expand-icon.c435c0ae.svg";